import { LastMessageSystem } from '@halo/ui-chat-react';
import type { MsgGroupUpdateContentProps } from './msg-group-update-content';
import { MsgGroupUpdateContent } from './msg-group-update-content';

export interface MsgGroupUpdatePreviewProps extends MsgGroupUpdateContentProps {}

export const MsgGroupUpdatePreview = memo(function MsgGroupUpdatePreview({
  message,
}: MsgGroupUpdatePreviewProps) {
  return (
    <LastMessageSystem>
      <MsgGroupUpdateContent message={message} />
    </LastMessageSystem>
  );
});
